import { Alert, Spin } from 'antd';
import { StyledActivity, StyledDemoWarning } from './Activity.styled';
import useActivity from './useActivity.hook';
import InteractiveVideoActivity from '@/shared/Activities/InteractiveVideoActivity/InteractiveVideoActivity';
import SongActivity from '@/shared/Activities/SongActivity/SongActivity';
import GameActivity from '@/shared/Activities/GameActivity/GameActivity';
import WorksheetActivity from './WorksheetActivity/WorksheetActivity';
import Link from 'next/link';
import { useContext, Fragment } from 'react';
import { FullscreenContext } from '../FullscreenContext/FullscreenContext';
import Button from '../Button/Button';
import ExternalActivity from './ExternalActivity/ExternalActivity';
import RealTimeActivity from './RealTimeActivity/Launchers/RealTimeActivity/RealTimeActivity';
import VideoActivity from './VideoActivity/VideoActivity';
import ComicActivity from './ComicActivity/ComicActivity';
import StoryWithQuestionsActivity from './StoryWithQuestionsActivity/StoryWithQuestionsActivity';
import PremiumContentWarning from './PremiumContentWarning/PremiumContentWarning';

export default function Activity({
  activity,
  activityConf,
  taskActivityConf,
  taskProgressActions,
  initialTaskProgress,
  isTaskActivityDone,
  isPreview,
  wrapperClassName,
}) {
  const fullscreenContext = useContext(FullscreenContext);
  const { state } = useActivity({
    activity,
    activityConf,
  });
  const TypeActivity = getTypeActivity(
    state.activity?.type,
    state.activity?.data
  );
  const showDemoWarning =
    state.canBeShown && state.activity?.data && state.demoMode;

  if (!state.canBeShown) {
    return <PremiumContentWarning isStudent={state.isStudent} />;
  }

  const Wrapper = wrapperClassName ? 'div' : Fragment;

  return (
    <Wrapper {...(wrapperClassName ? { className: wrapperClassName } : {})}>
      {showDemoWarning ? <DemoWarning /> : null}
      <StyledActivity className={showDemoWarning ? 'with-warning' : ''}>
        {state.activity?.data ? (
          <div
            className={`activity-wrapper  ${
              fullscreenContext.state.isFullscreen ? 'fullscreen' : ''
            }`}
          >
            <div className="activity-canvas">
              <TypeActivity
                activity={state.activity}
                activityConf={activityConf}
                taskActivityConf={taskActivityConf}
                taskProgressActions={taskProgressActions}
                initialTaskProgress={initialTaskProgress}
                isTaskActivityDone={isTaskActivityDone}
                demoMode={state.demoMode}
                isPreview={isPreview}
                className="activity"
              />
            </div>
          </div>
        ) : (
          <div className="loading">
            <Spin />
          </div>
        )}
        {state.activity?.description && !state.isStudent && !isPreview && (
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: activity.description,
            }}
          ></div>
        )}
      </StyledActivity>
    </Wrapper>
  );
}

function getTypeActivity(type, data) {
  return {
    video: VideoActivity,
    craft: VideoActivity,
    interactiveVideo: InteractiveVideoActivity,
    song: SongActivity,
    game: GameActivity,
    shortStory: data?.file ? WorksheetActivity : GameActivity,
    worksheet: WorksheetActivity,
    pictureDictionary: WorksheetActivity,
    realTime: RealTimeActivity,
    external: ExternalActivity,
    comic: ComicActivity,
    storyWithQuestions: StoryWithQuestionsActivity,
  }[type];
}

function DemoWarning() {
  return (
    <StyledDemoWarning>
      <Alert
        message={
          <span>
            This is a demo version.{' '}
            <Link href="/login" passHref>
              <Button type="primary">Log in</Button>
            </Link>{' '}
            or{' '}
            <Link href="/sign-up" passHref>
              <Button type="important">Sign up</Button>
            </Link>{' '}
            to view the full version
          </span>
        }
      />
    </StyledDemoWarning>
  );
}
